export default __webpack_public_path__ + "static/media/noexpl_07_EN.73b005d1.png";